import { DIG_SIG_FAIL, DIG_SIG_FAIL7, PIC_NOT_MATCHED } from 'common/constants';
import { SendEventDisbursement, sendException } from 'helpers/analytics';
import { getChannelContextCode } from 'helpers/Utility';
import { setError } from 'store/actions/auth';
import {
  countingTakePicture,
  resetCountingPicture
} from 'store/actions/disburse';

const handleDisbursementFailure = (dispatch, param) => {
  dispatch(setError('loanCreateFail'));
  param?.fail && param.fail();
};

const handleSelfieError = (dispatch, param) => {
  dispatch(countingTakePicture());

  if (param.selfieCount === 3) {
    dispatch(setError(DIG_SIG_FAIL));
    return;
  }

  if (param.selfieCount === 7) {
    dispatch(setError(DIG_SIG_FAIL7));
    dispatch(resetCountingPicture());
    return;
  }

  dispatch(setError(PIC_NOT_MATCHED));
  param?.picFailed && param.picFailed();
};

export const handleErrorValidatePhotoSignatureV3 = (
  dispatch,
  getState,
  err,
  param
) => {
  if (!err.response || err.code === 'ERR_NETWORK') {
    dispatch(setError('connection'));
    return;
  }

  const channelCode = getChannelContextCode(err, 'channel-context');

  if (channelCode === null) {
    param?.fail && param.fail();
    return;
  }

  const errorMap = {
    44001: {
      key: 'limit_usage',
      action: 'Daily limit usage privy'
    },
    101043: { key: 'contact-cs' }
  };

  if (errorMap[channelCode]) {
    const { key, action } = errorMap[channelCode];

    dispatch(setError(key));

    if (action) {
      SendEventDisbursement({
        action,
        isSecondApply: getState().loanApply.isSecondApply
      });
      sendException({ desc: action, fatal: 'true' });
    }
    return;
  }

  if (['211094', '200606', '100126'].includes(channelCode)) {
    handleDisbursementFailure(dispatch, param);
    return;
  }

  if (channelCode === '211057') {
    handleSelfieError(dispatch, param);
    return;
  }

  dispatch(setError('system'));
};
